// extracted by mini-css-extract-plugin
export default {"loader_container":"style_loader_container__XRcsR","spinner":"style_spinner__T2nBV","spin-anim":"style_spin-anim__PKqVg"};